import { Capacitor } from "@capacitor/core";

/** Build-time flag from CI (web vs capacitor bundle). */
export function getVitePlatform(): "web" | "mobile" {
  const v = import.meta.env.VITE_PLATFORM;
  return v === "mobile" ? "mobile" : "web";
}

/** Use native Preferences only in real Capacitor shell (not browser). */
export function isNativePreferencesBackend(): boolean {
  return Capacitor.isNativePlatform();
}
